// extracted by mini-css-extract-plugin
export default {"user":"styles_user__2O9xt","edit":"styles_edit__O9nZg","delete":"styles_delete__AjnyB","table_container":"styles_table_container__gtve+","userImage":"styles_userImage__XxJ4Z"};